import { render, staticRenderFns } from "./noticeCenter.vue?vue&type=template&id=070ffd72&scoped=true"
import script from "./noticeCenter.vue?vue&type=script&lang=js"
export * from "./noticeCenter.vue?vue&type=script&lang=js"
import style0 from "./noticeCenter.vue?vue&type=style&index=0&id=070ffd72&lang=scss"
import style1 from "./noticeCenter.vue?vue&type=style&index=1&id=070ffd72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ffd72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070ffd72')) {
      api.createRecord('070ffd72', component.options)
    } else {
      api.reload('070ffd72', component.options)
    }
    module.hot.accept("./noticeCenter.vue?vue&type=template&id=070ffd72&scoped=true", function () {
      api.rerender('070ffd72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navBar/noticeCenter.vue"
export default component.exports